import { Global, css } from "@emotion/react";

const GlobalStyle = (props: any) => <Global {...props} styles={css``} />;

export default GlobalStyle;
